"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
(0, manifest_1.registerSection)({
    type: 'gallery', label: 'Image gallery', icon: 'images', category: 'content',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default(''),
        columns: zod_1.z.number().int().min(2).max(5).default(3),
        ..._appearance_1.appearanceShape,
    }),
    blockTypes: { image: { label: 'Image', icon: 'image',
            settingsSchema: zod_1.z.object({ imageUrl: zod_1.z.string().default(''), caption: zod_1.z.string().max(160).default(''), href: zod_1.z.string().default('') }) } },
    maxBlocks: 12,
    defaults: () => ({ title: '', columns: 3, ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'columns', label: 'Columns', control: 'number', min: 2, max: 5, group: 'Content' },
        ..._appearance_1.appearanceFields,
    ],
    blockFields: {
        image: [
            { name: 'imageUrl', label: 'Image', control: 'image' },
            { name: 'caption', label: 'Caption', control: 'text' },
            { name: 'href', label: 'Link URL', control: 'url' },
        ],
    },
});
//# sourceMappingURL=gallery.js.map